import axios from "axios";
import { DOMAIN } from "../../constants";
import { getValidAccessToken } from "../authToken";

class AccountsApi {

    async login(email:string, password:string) {
        const { data } = await axios.post(`${DOMAIN}/api/accounts/login/`, { email, password });
        localStorage.setItem('userInfo', JSON.stringify(data));
    }

    logout() {
        localStorage.removeItem('userInfo');
    }

    private async authHeaders() {
        const token = await getValidAccessToken();
        return { headers: { Authorization: `Bearer ${token}` } };
    }

    async me() {
        const { data } = await axios.get(`${DOMAIN}/api/accounts/me/`, await this.authHeaders());
        return data;
    }

    async updateMe(payload: { first_name?: string; last_name?: string; company?: string }) {
        const { data } = await axios.patch(`${DOMAIN}/api/accounts/me/`, payload, await this.authHeaders());
        return data;
    }

    async changePassword(current_password: string, new_password: string) {
        const { data } = await axios.post(
            `${DOMAIN}/api/accounts/change-password/`,
            { current_password, new_password },
            await this.authHeaders(),
        );
        return data;
    }

};


const accountsApi = new AccountsApi();

export default accountsApi;
